export default function findStaff(search, typeId) {
  if (typeId === 2) {
    let name_Chel_com = search?.staff?.filter((x) => x.pivot.type === typeId);
    // console.log('newData name_Chel_com', name_Chel_com)
    return name_Chel_com;
  }
  let searchData = search?.staff?.find((x) => x.pivot.type === typeId);
  return searchData ? searchData.fullName : "";
}
